import './place-bet-bc.scss';
import { useEffect, useRef, useState } from 'react';
import bcFunction from '../bc-function';
import { ConfirmMoneyMiniBC, CountMoneyMiniBC, TypePlaceMiniBC } from 'models/mini-bc-model';
import { animateValue } from 'utils/function';

interface Props {
    moneyCount: CountMoneyMiniBC;
    moneyConfirm: ConfirmMoneyMiniBC;
    issue: number;
    result: number[] | null;
    onSelectBet: (placeEl: HTMLButtonElement, place: TypePlaceMiniBC) => void;
}
export default function PlaceBetBC(props: Props) {
    const { moneyCount, moneyConfirm, issue, result, onSelectBet } = props;

    const placeBetRef = useRef<HTMLParagraphElement[]>([]);

    // place animation chẵn
    const currentCountPlace = useRef<CountMoneyMiniBC>({
        moneyCountNai: 0,
        moneyCountBau: 0,
        moneyCountCua: 0,
        moneyCountTom: 0,
        moneyCountCa: 0,
        moneyCountGa: 0,
    });

    const [totalResult, setTotalResult] = useState<number | null>(null);
    const [totalBet, setTotalBet] = useState(0);

    useEffect(() => {
        if (result) {
            setTimeout(() => {
                const total = result.reduce((a, b) => Number(a) + Number(b), 0);
                setTotalResult(total);
            }, 3000);
        } else {
            setTotalResult(null);
        }
    }, [result]);

    useEffect(() => {
        currentCountPlace.current.moneyCountNai = 0;
        currentCountPlace.current.moneyCountBau = 0;
        currentCountPlace.current.moneyCountCua = 0;
        currentCountPlace.current.moneyCountTom = 0;
        currentCountPlace.current.moneyCountCa = 0;
        currentCountPlace.current.moneyCountGa = 0;
    }, [issue]);

    useEffect(() => {
        const total =
            moneyConfirm.moneyConfirmBau +
            moneyConfirm.moneyConfirmCua +
            moneyConfirm.moneyConfirmTom +
            moneyConfirm.moneyConfirmCa +
            moneyConfirm.moneyConfirmGa +
            moneyConfirm.moneyConfirmNai;
        setTotalBet(total);
    }, [moneyConfirm]);

    useEffect(() => {
        //bau
        placeBetRef.current.forEach((el) => {
            const index = Number(el.dataset.index);
            const methodName = el.dataset.typebet as TypePlaceMiniBC;
            if (methodName) {
                if (methodName === 'bau') {
                    if (moneyCount.moneyCountBau > currentCountPlace.current.moneyCountBau) {
                        animateValue(
                            placeBetRef.current[index],
                            currentCountPlace.current.moneyCountBau,
                            moneyCount.moneyCountBau,
                            200,
                            () => {
                                currentCountPlace.current.moneyCountBau = moneyCount.moneyCountBau;
                            }
                        );
                    }
                } else if (methodName === 'cua') {
                    if (moneyCount.moneyCountCua > currentCountPlace.current.moneyCountCua) {
                        animateValue(
                            placeBetRef.current[index],
                            currentCountPlace.current.moneyCountCua,
                            moneyCount.moneyCountCua,
                            200,
                            () => {
                                currentCountPlace.current.moneyCountCua = moneyCount.moneyCountCua;
                            }
                        );
                    }
                } else if (methodName === 'tom') {
                    //tom
                    if (moneyCount.moneyCountTom > currentCountPlace.current.moneyCountTom) {
                        animateValue(
                            placeBetRef.current[index],
                            currentCountPlace.current.moneyCountTom,
                            moneyCount.moneyCountTom,
                            200,
                            () => {
                                currentCountPlace.current.moneyCountTom = moneyCount.moneyCountTom;
                            }
                        );
                    }
                } else if (methodName === 'ca') {
                    //ca
                    if (moneyCount.moneyCountCa > currentCountPlace.current.moneyCountCa) {
                        animateValue(
                            placeBetRef.current[index],
                            currentCountPlace.current.moneyCountCa,
                            moneyCount.moneyCountCa,
                            200,
                            () => {
                                currentCountPlace.current.moneyCountCa = moneyCount.moneyCountCa;
                            }
                        );
                    }
                } else if (methodName == 'ga') {
                    //ga
                    if (moneyCount.moneyCountGa > currentCountPlace.current.moneyCountGa) {
                        animateValue(
                            placeBetRef.current[index],
                            currentCountPlace.current.moneyCountGa,
                            moneyCount.moneyCountGa,
                            200,
                            () => {
                                currentCountPlace.current.moneyCountGa = moneyCount.moneyCountGa;
                            }
                        );
                    }
                } else if (methodName === 'nai') {
                    //nai
                    if (moneyCount.moneyCountNai > currentCountPlace.current.moneyCountNai) {
                        animateValue(
                            placeBetRef.current[index],
                            currentCountPlace.current.moneyCountNai,
                            moneyCount.moneyCountNai,
                            200,
                            () => {
                                currentCountPlace.current.moneyCountNai = moneyCount.moneyCountNai;
                            }
                        );
                    }
                }
            }
        });
    }, [moneyCount]);

    const selectPlace = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>, 
        place: TypePlaceMiniBC
      ) => {
        const btnEl = event.currentTarget; // safer than event.target
      
        if (btnEl instanceof HTMLButtonElement) {
          onSelectBet(btnEl, place);
        } else {
          console.warn('Expected a button element but got something else:', btnEl);
        }
      };

    const addRefMoney = (el: HTMLParagraphElement | null, index: number) => {
        if (el && placeBetRef.current) {
            placeBetRef.current[index] = el;
        }
    };

    return (
        <div className="place-bet-bc">
            <div className='ion-row'>
                {bcFunction.bcFade.map((item, index) => (
                    <div className='ion-col' key={item.methodname}>
                        <button
                            className="place-item btn-reset"
                            data-infinity={item.methodname}
                            onClick={(e) => selectPlace(e, item.methodname)}
                        >
                            <div className="place-inner">
                                <span className="win-effect"></span>
                                <img className="bg-place" src={require(`assets/images/mini-bc/place-${item.methodname}.png`)} />
                                <div className="inner-btn">
                                    <p className="odd-text">{item.odds}</p>
                                    <p className="total-money-typebet">
                                        <span></span>
                                    </p>
                                    {moneyConfirm[item.keyMoneyConfirm] > 0 && (
                                        <p className="total-money">
                                            <span>{new Intl.NumberFormat().format(moneyConfirm[item.keyMoneyConfirm] || 0)}</span>
                                        </p>
                                    )}
                                </div>
                                <div className="countMoney">
                                    <div className="count-inner">
                                        <p data-typebet={item.methodname} data-index={index} ref={(el) => addRefMoney(el, index)}>
                                            {new Intl.NumberFormat().format(moneyCount[item.keyTotalMoney] || 0)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
